import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_update = createAsyncThunkSafe<void, DTO__workspace>(
  ENUM__network_event_client_to_server.WORKSPACE_UPDATE,
  async (workspace): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_UPDATE, workspace);
  },
);

export function init_remote_workspace_update(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_update.pending, (state, action) => {})
    .addCase(remote_workspace_update.rejected, (state, action) => {})
    .addCase(remote_workspace_update.fulfilled, (state, action: PayloadAction) => {});
}
